import { render, staticRenderFns } from "./all-batches.vue?vue&type=template&id=5844087c&"
import script from "./all-batches.vue?vue&type=script&lang=js&"
export * from "./all-batches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports